module.exports = __webpack_public_path__ + "static/media/logos_166x50_hkbu.66cfbcc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_166x50_hkbu.jpg
// module id = 216
// module chunks = 0